(function () {
  const emails = document.querySelectorAll<HTMLSpanElement>('.email-address-block');
  if (emails.length > 0) {
    emails.forEach((email) => {
      try {
        const part1 = email.getAttribute('data-part-1');
        const part2 = email.getAttribute('data-part-2');
        if (email.classList.contains('email-address-block--added')) {
          return;
        }

        if (part1 && part2) {
          const complete = `${part1}@${part2}`;

          email.innerHTML = `<a href="mailto:${complete}">${complete}</a>`;
          email.classList.add('email-address-block--added');
        }
      } catch (e) {
        console.log(e);
      }
    });
  }
})();
